import _ from 'lodash';
import { TABLE_CLIENT_STATE_LATEST_VERSION } from './table-client-state-init';
export function reuseClientState(vizModel) {
    const vizProps = _.cloneDeep(vizModel.vizProps);
    if (_.isNil(vizProps) ||
        _.isNil(vizProps.tableVizPropVersion) ||
        vizProps.tableVizPropVersion !== TABLE_CLIENT_STATE_LATEST_VERSION) {
        throw new Error('incompatible viz props received');
    }
    const columnIds = vizModel.columns.map(colJson => colJson.id);
    if (!_.isEmpty(vizProps.columnProperties)) {
        const columnProperties = vizProps.columnProperties.filter(colMap => columnIds.includes(colMap.columnId));
        vizProps.columnProperties = columnProperties;
    }
    if (!_.isEmpty(vizProps.orderedColumnIds)) {
        const orderedColumnIds = vizProps.orderedColumnIds.filter(colId => columnIds.includes(colId));
        vizProps.orderedColumnIds = orderedColumnIds;
    }
    if (!_.isEmpty(vizProps.widthState)) {
        const widthState = vizProps.widthState.filter(colMap => columnIds.includes(colMap.columnId));
        vizProps.widthState = widthState;
    }
    return vizProps;
}
//# sourceMappingURL=table-reuse-client-state.js.map